import format from "date-fns/format";
import parse from "date-fns/parse";
import qs from "query-string";

export interface IProductHistoryFilter {
  createdDate?: Date;
}

export function productHistoryFilterToQueryParams(filter: IProductHistoryFilter): string {
  if (!filter.createdDate) {
    return "";
  }

  return qs.stringify({
    createdDate: format(filter.createdDate, "yyyy-MM-dd"),
  });
}

export function productHistoryQueryParamsToFilter(queryString: string): IProductHistoryFilter {
  const queryParams = qs.parse(queryString);
  const filter: IProductHistoryFilter = {};

  if (queryParams.createdDate) {
    filter.createdDate = parse(queryParams.createdDate?.toString(), "yyyy-MM-dd", new Date());
  }

  return filter;
}
